import { useContext } from "react";
import "./classview.css";
import Lang from "../../../components/Lang";
import Staff from "../../../components/Staff";
import { CenterContext } from "../../../../../Context";
import LinearProgress from "../../../components/LinearProgress";

export default function ClassView({ htClass, setSelected }) {

  return (
    <div
      onClick={() => {
        if (!htClass.cancelledReason) setSelected(htClass._id);
      }}
      className={
        htClass.cancelledReason ? "cancelled-frame" : "attendance-frame"
      }
    >
      <div style={{ padding: 5, paddingLeft: 10 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              fontSize: 14,
              color: "white",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: 200,
            }}
          >
            {htClass.name}
          </div>
          <div style={{ fontSize: 14, color: "yellow" }}>
            {htClass.test ? (
              "Test"
            ) : htClass.feedbacks ? (
              <FbComplete
                feedbacks={htClass.feedbacks}
                ai={htClass.aiReviewed}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <div style={{ fontSize: 12, color: "yellow" }}>
          <Staff id={htClass.teacher} />
        </div>
        <div style={{ fontSize: 12, color: "aqua" }}>
          {htClass.foreignTeacher ? (
            <div>
              <Staff id={htClass.foreignTeacher} /> {htClass.FTStartTime} - {htClass.FTEndTime}
            </div>
          ) : (
            <div style={{ color: "lightgrey" }}>No foreign teacher</div>
          )}
        </div>
        <div style={{ fontSize: 12, color: "lightblue" }}>{htClass.room}</div>
      </div>
      <LinearProgress
        value={
          htClass.attended.length +
          htClass.late.length +
          htClass.absent.length +
          htClass.noShow.length
        }
        outOf={htClass.students.length}
        width={185}
        height={2}
        className="ml-2 mr-2 mb-1 mt-1"
      />
      <div className="attendance-students-frame">
        <div
          style={{
            color: "#FFFFFF",
            backdropFilter: "blur(4px)",
          }}
        >
          <Lang w="students" />: {htClass.students.length}
          <div style={{ marginTop: 7 }}></div>
        </div>
        <div>
          <DrawAttendanceHtClass htClass={htClass} />
        </div>
      </div>
    </div>
  );
}


function FbComplete({ feedbacks, ai }) {
  
  const { center } = useContext(CenterContext)
 
  let color = "limegreen"
  for (const f of feedbacks) {
   
    for (const category of center.feedbackCategories) {
      if(!f.feedback ||!f.feedback[category]) color="orange"
    }
     if (!f.notes || f.notes === "") color = "red";
  }


  return (
    <div style={{ color, fontWeight: "bold", display: "flex", gap:5 }}>
      <div>Feedback</div> {ai ? <div style={{ display: "flex", gap:5, color:"white" }}><div>AI</div><div style={{color: getColor(getAverage(feedbacks))}}> {getAverage(feedbacks)}</div></div> : <div></div>}
    </div>
  );
}

function getColor(score) {
  let color = "limegreen";
  if (score < 7) color = "goldenrod";
  if (score < 5) color = "pink";
  return color;
}

function getAverage(feedback) {
  try {
    console.log(feedback.map((f) => f.aiScore))
    let scores = feedback.map((f) => f.aiScore);
    let sum = scores.reduce((a, b) => a + b, 0);
    if (scores.length === 0) return <>0</>;
    const average = (10 / (scores.length * 10)) * sum;

    if (average) return average.toFixed(1);
    return 0;
  } catch (e) {
    return 0;
  }
}


function DrawAttendanceHtClass(props) {
  let { htClass } = props;
/*   let attended =
    htClass.lesson && htClass.lesson.attended
      ? htClass.lesson.attended.length
      : 0;
  let late =
    htClass.lesson && htClass.lesson.late ? htClass.lesson.late.length : 0;
  let absent =
    htClass.lesson && htClass.lesson.absent ? htClass.lesson.absent.length : 0;
  let noShow =
    htClass.lesson && htClass.lesson.noShow
      ? htClass.lesson.noShow.length
      : "0"; */

  return (
    <div>
      {" "}
      <div
        style={{ display: "flex", lineHeight: 1.2, color:"limegreen" }}
        
      >
        <div style={{ position: "relative", left: 40 }}>Attended:</div>{" "}
        <div
          style={{
            position: "relative",
            left: 35,
            textAlign: "right",
            width: 20,
          }}
        >
          {htClass.attended.length}
        </div>
      </div>
      <div
        style={{ display: "flex", lineHeight: 1.2, color:"yellow" }}

      >
        <div style={{ position: "relative", left: 40 }}>Late:</div>{" "}
        <div
          style={{
            position: "relative",
            left: 61,
            textAlign: "right",
            width: 20,
          }}
        >
          {htClass.late.length}
        </div>
      </div>
      <div
        style={{ display: "flex", lineHeight: 1.2 }}
        className="text-orange-400"
      >
        <div style={{ position: "relative", left: 40 }}>Absent:</div>
        <div
          style={{
            position: "relative",
            left: 46,
            textAlign: "right",
            width: 20,
          }}
        >
          {htClass.absent.length}
        </div>
      </div>
      <div style={{ display: "flex", lineHeight: 1.2, color: "#fa8989" }}>
        <div style={{ position: "relative", left: 40, width: 60 }}>
          No Show:
        </div>
        <div
          style={{
            position: "relative",
            left: 28,
            textAlign: "right",
            width: 20,
          }}
        >
          {htClass.noShow.length}
        </div>
      </div>
    </div>
  );
}
